// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-comments-threads-list .list-enter-active,.w-comments-threads-list .list-leave-active{transition:all 1s}.w-comments-threads-list .list-enter,.w-comments-threads-list .list-leave-to{opacity:0;transform:translateY(-30px)}.w-comments-threads-list .list-move{transition:transform 1s}", ""]);
// Exports
module.exports = exports;
